import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-dark-900 pt-10 pb-10 px-4 relative overflow-hidden" data-id="element-118">
      {/* Soft radial accent — kept subtle so the mockup pops */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gold/10 rounded-full blur-[140px] pointer-events-none" data-id="element-119"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-121">
          <span className="inline-block text-xs md:text-sm text-muted bg-[#312052] border border-white/10 rounded-full px-4 py-1 mb-4" data-id="element-122">
            📗 BibliotecaDigital.online
          </span>
          <h1 className="font-bold text-cream mb-3 text-2xl md:text-4xl leading-tight" data-id="element-123">
            Menos Celular. Más Cerebro.
          </h1>
          <p className="text-gold font-semibold text-xl md:text-2xl mb-3 tracking-wide" data-id="element-124">
            Método Mente Enfocada
          </p>
          <p className="text-cream text-base md:text-lg max-w-2xl mx-auto mb-1" data-id="element-125">
            Activa la mente de tu hijo en 21 dias.
          </p>
          <p className="text-muted text-sm md:text-base max-w-2xl mx-auto" data-id="element-126">
            Sin peleas, sin pantallas, sin vueltas. 6 Tomos + 6 Bonos · Niños de
            4 a 12 años.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="my-6 md:my-8" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/uhFQLxSLmdigWef6oY9aWc/MOCKUP_NINOS_MENTE_ENFOCADA.png" alt="Método Mente Enfocada" className="w-full max-w-[340px] md:max-w-[460px] mx-auto drop-shadow-[0_25px_60px_rgba(0,0,0,0.55)]" data-id="element-128" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="max-w-2xl mx-auto" data-id="element-129">
          <a href="#pricing" className="inline-block bg-cta hover:bg-cta-hover text-white font-bold text-base md:text-xl py-4 px-8 md:px-10 rounded-full shadow-[0_10px_30px_rgba(34,199,168,0.35)] transition-all hover:scale-105 active:scale-95 mb-5" data-id="element-130">
            👉 QUIERO ACTIVAR LA MENTE DE MI HIJO AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-5 text-sm text-muted" data-id="element-131">
            <div className="flex items-center" data-id="element-132">
              <Shield className="w-4 h-4 mr-1 text-gold" data-id="element-133" /> Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-134">
              <Lock className="w-4 h-4 mr-1 text-gold" data-id="element-135" /> Pago seguro
            </div>
            <div className="flex items-center" data-id="element-136">
              <CreditCard className="w-4 h-4 mr-1 text-gold" data-id="element-137" /> Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}